import { render, staticRenderFns } from "./UnitKerja.vue?vue&type=template&id=33231c05"
import script from "./UnitKerja.vue?vue&type=script&lang=js"
export * from "./UnitKerja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports